export default "__VITE_ASSET__DO3mWstm__"